import gql from 'graphql-tag';
import { useQuery, provideApolloClient } from '@vue/apollo-composable';
import { watch } from 'vue';
import useAlerts from './useAlerts';
import apolloClient from './useApolloClient';

const { addAlert } = useAlerts();

const GET_CONTACT = gql`
  query ContactQuery($contactId: ID!) {
    contact(id: $contactId) {
      CONTACTID
      FIRSTNAME
      LASTNAME
      CATEGORY
      CUST_Employment_023149966
      INSIDESALES
      OUTSIDESALES
      PRICINGLEVELID
      CUSTOMERDETAILS
      VENDORDEPT
      VENDORDETAILS
      TITLES
      DEPARTMENTS
      BIRTHDATE
      SALESCONTACT
      NA
      ARCHITECTDETAILS
      ISPRIMARY
      INACTIVE
      email {
        ADDRESS
      }
      company {
        COMPANYID
        NAME
        CATEGORY
        INSIDESALES
        OUTSIDESALES
        CUSTOMERDETAILS
        VENDORDEPT
        VENDORDETAILS
        WEBADDRESS
        phones {
          NUMBERDISPLAY
          TYPEID
        }
      }
      address {
        LINE1
        LINE2
        CITY
        STATE
        POSTALCODE
        COUNTRYNAME
      }
      phones {
        NUMBERDISPLAY
        TYPEID
        EXT
      }
    }
  }
`;

export default function useContactQuery() {
  return function (contactId) {
    provideApolloClient(apolloClient);

    const { result, loading, error, refetch } = useQuery(GET_CONTACT, { contactId }, { fetchPolicy: 'no-cache' });

    watch(error, () => {
      if (error.value) {
        console.error('Error fetching individual:', error.value);
        addAlert('Error fetching individual', 'high', 5);
      }
    });

    return {
      result,
      loading,
      error,
      refetch,
    };
  };
}
